/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublishProjectRequest,
  TPublishProjectModel,
  IMappers,
  TPublishProjectResponse,
  TPublishProjectResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createPublishProjectModel(parameters: TPublishProjectRequest): TPublishProjectModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'promotions-flow-control',
    pathApi: '/v1/publish-project/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublishProjectOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublishProjectRequest;
}

export async function fetchPublishProject<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublishProjectOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublishProjectResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublishProjectModel(parameters),
    config,
  )) as FetchResponse<TPublishProjectResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublishProjectResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublishProjectResponse>;
}
